/* * 主页 */
<template>
    <!-- <VerticalSlide ref="verticalSlide"> -->
    <!-- <div class="slip_banner"> -->
    <!-- 全屏banner -->
    <!-- </div> -->
    <div
        ref="mainWrapper"
        class="home-page-view cls-top-menu-page"
    >
        <div
            ref="viewScrollContent"
            class="home_wrap scroll-view-scroll tran"
        >
            <!-- 小喇叭 -->
            <!-- <Tip
        v-if="tipContent"
        :content="tipContent"
      >
      </Tip>-->
            <!-- <Tip
        v-if="tipContent"
        :content="tipContent"
      ></Tip>-->
            <!-- 首页轮播图 -->
            <Banner
                :isLoop="isLoop"
                class="tran"
                ref="homeBanner"
            ></Banner>

            <!-- <Banner
                :isLoop="isLoop"
                :list="list"
                class="tran"
                :isOpenActivity="isOpenActivity"
                :ActivityBannerObj="ActivityBannerObj"
                :bannerBgColor="bannerBgColor"
                ref="homeBanner"
      ></Banner>-->
            <!-- 第一个广告 -->
            <!-- <div class="smallFloatingLayer" v-if="bannerInfo.isShowBanner">
          <SmallFloatingLayer :itemAd="bannerInfo" :itemId="1"></SmallFloatingLayer>
      </div>-->
            <FreePeriodRemind
                :data="freeperiodremindlist"
                :swiperOption="swiperOption"
                ref="freePeriodRemind"
            />
            <!-- 爆款楼层 -->
            <HotGoodFloor ref="hotGoodFloorWrap" />
            <!-- 专属免息 -->
            <!-- <ExclusiveInterestFree
                ref="homePageInterestFree"
                @onloadInterestFreeList="onloadInterestFreeList"
            />
            <HomePageDailySelectFixed
                ref="homePageDailySelect"
                @onLoadedDailySelect="onLoadedDailySelect"
      />-->
            <!-- 以上ExclusiveInterestFree，HomePageDailySelectFixed两个组件替换为供应链3+3、一行四个组件 -->
            <!-- 供应链组件start -->
            <!-- <div
        style="min-height: 507px;"
        class="jdTwoRowThreeCol"
        data-appid="A230943810133041152"
      ></div>
      <div
        style="min-height: 146px;"
        class="jdOneRowFourCol"
        data-appid="A230938078042112000"
      ></div> -->
            <!-- 供应链组件end -->
            <!-- <HomePageDailySelect1to3
                ref="homePageDailySelect"
                @onLoadedDailySelect="onLoadedDailySelect"
      ></HomePageDailySelect1to3>-->

            <!-- 首页活动列表 -->
            <HomePageActivityList
                ref="homePageActivityList"
                @onBetterScrollRefresh="onPageActivityBetterScrollRefresh"
                @onEditTip="onEditTip"
            />
            <!-- 首页猜你喜欢列表 -->
            <!-- <HomeGuessWhatYouLike
                ref="homeGuessWhatYouLike"
                :categorys="guessLikeCategorys"
                :navigaterBarScrollCurrentIndex="guessLikeCurrentIndex"
                @onBetterScrollRefresh="onHomeGuessWhatYouLikeRefresh"
                @onItemClick="loadGuessLikeByCategory"
                @onNavBarScroll="onNavBarScroll"
                @onNavBarScrollEnd="onNavBarScrollEnd"
      />-->
            <div class="addnewcls">
                <div
                    class="jdOneThreeColMoreRowNew"
                    data-appid="A268316133753249792"
                ></div>
                <div
                    class="jdOneRowTuoThreeColNew"
                    data-appid="A268316653552271360"
                ></div>
                <div
                    class="jdOneRowTuoThreeColNew"
                    data-appid="A296921678511820800"
                ></div>
                <div
                    class="jdOneRowTuoThreeColNew"
                    data-appid="A268317414638190592"
                ></div>
                <div
                    class="jdOneRowTuoThreeColNew"
                    data-appid="A268317847592001536"
                ></div>
                <!-- <div
          class="jdOneRowTuoThreeColNew"
          data-appid="A268318102537502720"
        ></div> -->
            </div>
            <!-- 首页猜你喜欢快捷版mix方案 -->
            <HomeNewWhatDoYouLike v-if="mixSwitch" />
            <!-- <div class="jdGylSearch" ></div> -->
            <!-- <div class="jdGylBanner" data-appid="1000_C1000987468.page.A287757204448043008"></div> -->
            <!-- <div class="jdGylBanner" data-appid="1000_C1000987468.page.A287763198167179264"></div> -->
            <!-- <div class="jdGylBanner" data-appid="1000_C1002074000.page.A288482926646951936"></div> -->
            <div
                v-show="!mixSwitch"
                class="jdMixWaterfall"
                id="jdMixWaterfall"
            ></div>
            <!-- <div v-show="!mixSwitch" class="jdMixFeed" data-appid="A237724365837221888"></div> //预发 -->
            <div
                v-show="!mixSwitch && jdRecSwitch"
                class="jdRecommend"
                :style="{ bottom: isIphonex ? '5.25rem' : '3.25rem' }"
            >
                <div class="recTips">算法服务由京东商城提供,此功能会共享您的设备信息、浏览信息等数据到京东商城。</div>
                <div
                    @click="ImKnow()"
                    class="ImSure"
                >我知道了</div>
                <div
                    @click="jdRecSwitch = false"
                    class="ImClose"
                >
                    <div class="xx">x</div>
                </div>
            </div>
            <!-- 发现页和个人中心入口 -->
        </div>

        <FindCenter v-if="hasFindCenter"></FindCenter>
        <NavigationJd
            v-if="hasJdNav && fromBusiness === false"
            ref="nav"
            :isShow="true"
        />
        <Navigation
            v-if="hasNav && fromBusiness === false"
            ref="nav"
            :isShow="true"
        />
        <Search
            v-if="fromBusiness === false"
            :isScroll="isScroll"
            class="ui-fixed"
        />
        <BottomSuspension />
        <!-- <AdvertisingMsterDialog /> -->
    </div>
    <!-- </VerticalSlide> -->
</template>
<script>
// import ScrollView from '@/components/ScrollView.vue';
// import VerticalSlide from '@/components/VerticalSlide.vue';
import Banner from '@/buscomponents/Banner.vue';
// import SmallFloatingLayer from '@/buscomponents/SmallFloatingLayer.vue';
// import HomeGuessWhatYouLike from '@/buscomponents/HomeGuessWhatYouLike.vue';
import HomePageActivityList from '@/buscomponents/HomePageActivityList.vue';
//import HomePageDailySelect from '@/buscomponents/HomePageDailySelect.vue';
// import HomePageDailySelect1to3 from '@/buscomponents/HomePageDailySelect1to3.vue';
// import HomePageDailySelectFixed from '@/buscomponents/HomePageDailySelectFixed.vue';
// import NavigaterBarScroll from '@/buscomponents/NavigaterBarScroll.vue';
import FindCenter from '@/buscomponents/FindCenter.vue';
import Search from '@/buscomponents/Search.vue';
import request from '@/util/request';
import { shareInit, HideShare, closeXview } from '@/util/share';
import { setJDJRNativeHeaderColor } from '@/util/jdjrNative';
import { genLinkBySSR, isJdNavFun, hasNavFun, delay, getStaticConfig, isEmptyObj, isIphonex } from '@/util/common';
import Slider from '@/components/Slider.vue';
import Navigation from '@/buscomponents/Navigation.vue';
import { messages } from '@/config';
import HomeNewWhatDoYouLike from '@/buscomponents/HomeNewWhatDoYouLike.vue';
import NavigationJd from '@/buscomponents/NavigationJd.vue';
import Tip from '@/buscomponents/Tip.vue';
import FreePeriodRemind from '@/buscomponents/FreePeriodRemind.vue';
import BottomSuspension from '@/buscomponents/BottomSuspension.vue';
// import ExclusiveInterestFree from '@/buscomponents/ExclusiveInterestFree.vue';
import HotGoodFloor from '@/buscomponents/HotGoodFloor.vue';
// import AdvertisingMsterDialog from '@/buscomponents/AdvertisingMsterDialog.vue';
import { openByKpl } from '@/util/kpl';
import { getQuery } from '@/util/url';
import { GetSever, PostSever, GwPostSever } from '@/util/sqRequestService';
// import * as vConsole from "vconsole";
// if (
//     $.device.jdjr &&
//     (window.location.host.indexOf("jddx-pre") > -1 ||
//         window.location.host.indexOf("jddx-test") > -1)
// ) {
//     const vconsole = new vConsole();
// }
let mixPositionCode = 'mxxqsy.index.switch';
let domain = `${location.protocol}//ms.jr.jd.com`;
switch (process.env.VUE_APP_ENV) {
    // case 'dev':
    case 'minner':
        mixPositionCode = 'mxxqpre.index.switch';
        domain = `${location.protocol}//msinner.jr.jd.com`;
        break;
    case 'dev':
        mixPositionCode = 'mxxqpre.index.switch';
        domain = `${location.protocol}//msinner.jr.jd.com`;
        break;
    default:
        mixPositionCode = 'mxxqsy.index.switch';
        domain = `${location.protocol}//ms.jr.jd.com`;
        break;
}

export default {
    name: 'home',
    components: {
        // ScrollView,
        // SmallFloatingLayer,
        // NavigaterBarScroll,
        // HomeGuessWhatYouLike,
        HomePageActivityList,
        // HomePageDailySelect1to3,
        Slider,
        // VerticalSlide,
        Banner,
        Navigation,
        FindCenter,
        NavigationJd,
        Tip,
        Search,
        FreePeriodRemind,
        BottomSuspension,
        // AdvertisingMsterDialog,
        // ExclusiveInterestFree,
        // HomePageDailySelectFixed,
        HotGoodFloor,
        HomeNewWhatDoYouLike
    },
    props: {
        fromBusiness: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // list: swiperImgs,
            list: [],
            isOpenActivity: false,
            ActivityBannerObj: {},
            bannerBgColor: '#fff',
            isScroll: false,
            isLoop: true,
            tempGuessLikeCategorys: [],
            guessLikeCategorys: [],
            dailySelect: [],
            // 第一个banner
            bannerInfo: {
                isShowBanner: false
            },
            isBarFixed: false,
            guessLikeCurrentIndex: 0,
            hasFindCenter: false,
            hasJdNav: false,
            hasNav: false,
            tipContent: '',
            // 节流函数
            //优享-免息提醒
            freeperiodremindlist: [],
            swiperOption: {
                direction: 'vertical',
                loop: true,
                speed: 600,
                allowTouchMove: false,
                on: {
                    click: function() {
                        const realIndex = this.realIndex;
                        this.handleClickSlide(realIndex);
                    }
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                }
                // autoplay: false
            },
            loadTime: 150, //内外联动
            mixSwitch: false, //猜你喜欢组件替换mix瀑布流组件双十一兜底开关
            jdRecSwitch: false, //新用户进入标识，默认为新用户，根据接口判断，true展示小提示
            isIphonex: isIphonex() ? true : false
        };
    },
    created() {
        console.log('createdcreatedcreatedcreatedcreated');
        this.getFreeInterestCallList();
        try {
            HideShare({ title: '优享免息', moreItem: true, hideTools: false, textColor: 1 });
            const defaultOption = {
                shareURL: genLinkBySSR('activity'),
                shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
                shareTitle: messages.shareTitle,
                shareDesc: messages.shareDesc,
                shareChannels: ['0', '1', '3']
            };
            shareInit(defaultOption);
        } catch (error) {
            console.log(error);
        }

        // this.timeLimeUpDown();
        // this.list = swiperImgs;
        const hasNav = hasNavFun(this.$route);
        const isJdNav = isJdNavFun(this.$route);
        if (isJdNav) {
            this.hasFindCenter = true;
        }
        if (hasNav) {
            if (isJdNav) {
                this.hasJdNav = true;
            } else {
                this.hasNav = true;
            }
        }
        if ($.device && $.device.jdjr) {
            const _href = window.location.href;
            const hrefParam = getQuery(_href);
            if (hrefParam && JSON.stringify(hrefParam) != '{}' && hrefParam.isFromCart && hrefParam.isFromCart == 'jrHome') {
                let _sku = hrefParam.skuId ? hrefParam.skuId : '';
                let _xxfSceneId = hrefParam.xxfSceneId ? hrefParam.xxfSceneId : '';
                if (_sku) {
                    _sku = _sku.toString();
                }
                window.history.replaceState(null, null, window.location.protocol + `//jddx.jd.com/m/jddnew/index.html?tab=mx`);
                // window.history.replaceState(null, null, window.location.protocol + `//${window.location.hostname}/btyingxiao/sfstore/index.html#/home`);
                setTimeout(() => {
                    let open = openByKpl;
                    if (this.$openByKpl) {
                        open = this.$openByKpl;
                    }
                    // open({
                    //     url: 'https://p.m.jd.com/cart/cart.action',
                    //     eventId: 'MInterestFree_BottomNavCart'
                    // });
                    // window.location.href = 'https://p.m.jd.com/cart/cart.action';
                    window.location.href = `https://jddx.jd.com/m/react/index.html?skuId=${_sku}#@@{"params":{"skuId":${_sku}},"hash":"productIndex"}@@?xxfSceneId=${_xxfSceneId}`;
                }, 500);
            }
        }
        this.getMixFeed();
    },
    computed: {
        scrollHeight: () => {
            return document.body.scrollHeight;
        }
    },
    mounted() {
        console.log('mountedmountedmountedmounted');
        this.switchPromise()
            .then(result => {
                this.initRewardAuto();
            })
            .catch(() => {
                console.log('不满足浏览任务组件rewardAuto的渲染条件');
                setTimeout(() => {
                    const articleReward = new JDDXReward.ArticleReward();
                    console.log(articleReward);
                    articleReward.setRewardBarStyle(`display: block;position: fixed;bottom: 120px;z-index: 99999;`);
                    articleReward.init();
                    articleReward.setActId(19);
                    articleReward.renderArticleRead();
                    // const articleReward = new JDDXSDK.ArticleReward();
                    // console.log(articleReward);
                    // articleReward.setRewardBarStyle(`display: block;position: fixed;bottom: 130px;z-index: 99999;`);
                    // articleReward.init();
                    // articleReward.setActId(19);
                    // articleReward.renderArticleRead();
                }, 0);
            });
        var g = document.createElement('script');
        g.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'jddx.jd.com/m/outputjs/newbundle.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(g, s);
        if (g.addEventListener) {
            g.addEventListener('load', function() {
                window.gylComponent && window.gylComponent.initJdThreeColMoreRow();
                window.gylComponent && window.gylComponent.initOneTuoThree();
                // window.gylComponent.initSearch({
                //   appid: '1000_C1000987468.page.A287138863173804032'
                // });
                window.gylComponent.initBanner();
                // window.gylComponent && window.gylComponent.initMix({ appid: 'A241024138932592640' });
                window.gylComponent && window.gylComponent.initMix({ appid: 'A241024138932592640' });
            });
        }
        // this.onLoadedDailySelect();
        // this.onloadInterestFreeList();
        // this.resetViewScrollContent(true);
        // let startClintY = 0;
        // $(this.$refs.mainWrapper).on('touchstart', e => {
        //   const { touches } = e;
        //   startClintY = touches[0].clientY;
        // });

        // $(this.$refs.mainWrapper).on('touchmove', e => {
        //   const { touches } = e;
        //   const moveClintY = touches[0].clientY;
        //   const dis = moveClintY - startClintY;
        //   if (Math.abs(this.$refs.scrollViewNav.scroll.y) === 0) {
        //     if (dis < 0) {
        //       this.$refs.scrollViewNav.scroll.enable();
        //     } else {
        //       this.$refs.scrollViewNav.scroll.disable();
        //       this.$refs.verticalSlide.slide.enable();
        //     }
        //   } else {
        //     this.$refs.verticalSlide.slide.disable();
        //     this.$nextTick(() => {
        //       this.$refs.verticalSlide.slide.goToPage(0, 1);
        //     });
        //   }
        // });
        // let qs = getQuery();
        // let _n = 0;
        // if (document.querySelector('.jdOneRowFourCol') && $.device.jdjr && qs.from == 'jrEveryDay') {
        //   window.onload = function() {
        //     let m = setTimeout(() => {
        //       clearTimeout(m);
        //       let _top = document.querySelector('.jdOneRowFourCol').offsetTop;
        //       console.log(_top, '-=-=-=-=-');
        //       _n = +_top - 50;
        //       window.scrollTo(0, _n);
        //     }, 360);
        //   };
        // }
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let qs = getQuery();
        if ($.device && $.device.jdjr) {
            let _jxHeight = 0;
            if (qs.from == 'jrEveryDay') {
                this.loadTime = 1200;
                setTimeout(() => {
                    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    const _HomeBannerHeight = this.$refs.homeBanner.HomeBannerHeight; //banner+icon高度
                    const _hotGoodFloorWrapHeight = this.$refs.hotGoodFloorWrap.hotGoodFloorWrapHeight; //爆款楼层
                    const zoomHeight = _HomeBannerHeight + _hotGoodFloorWrapHeight + 520;
                    let wrappers = document.getElementsByClassName('cls-discovery_warpper');
                    if (wrappers && wrappers.length) {
                        if (zoomHeight >= clientHeight) {
                            document.getElementsByClassName('cls-discovery_warpper')[0].scrollTop = zoomHeight - 100;
                        } else {
                            document.getElementsByClassName('cls-discovery_warpper')[0].scrollTop = 0;
                        }
                    } else {
                        if (zoomHeight >= clientHeight) {
                            $('body,html').scrollTop(zoomHeight - 100);
                        } else {
                            $('body,html').scrollTop(0);
                        }
                    }
                }, 1200);
            }
            // if (qs.from == 'jdjr' && qs.otherSku) {
            //   this.loadTime = 1200;
            //   setTimeout(() => {
            //     const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //     const _HomeBannerHeight = this.$refs.homeBanner.HomeBannerHeight;
            //     const _freePeriodRemindHeight = this.$refs.freePeriodRemind.freePeriodRemindHeight;
            //     const _dailySelectHeight = this.$refs.homePageDailySelect.dailySelectHeight;
            //     const _interestFreeHeight = this.$refs.homePageInterestFree.interestFreeHeight;
            //     const _hotGoodFloorWrapHeight = this.$refs.hotGoodFloorWrap.hotGoodFloorWrapHeight;
            //     const zoomHeight = _HomeBannerHeight + _freePeriodRemindHeight + _interestFreeHeight + _dailySelectHeight + _hotGoodFloorWrapHeight;
            //     let wrappers = document.getElementsByClassName('cls-discovery_warpper');
            //     if (wrappers && wrappers.length) {
            //       if (zoomHeight + 30 >= clientHeight) {
            //         document.getElementsByClassName('cls-discovery_warpper')[0].scrollTop = clientHeight;
            //       } else {
            //         document.getElementsByClassName('cls-discovery_warpper')[0].scrollTop = 0;
            //       }
            //     } else {
            //       if (zoomHeight + 30 >= clientHeight) {
            //         $('body,html').scrollTop(clientHeight + 100);
            //       } else {
            //         $('body,html').scrollTop(0);
            //       }
            //     }
            //   }, 1000);
            // } else {
            //   this.loadTime = 150;
            //   setTimeout(() => {
            //     this.$nextTick(() => {
            //       if (window.scrollTo) {
            //         window.scrollTo(0, 0);
            //       }
            //     });
            //   }, 200);
            // }
        } else {
            this.loadTime = 150;
            setTimeout(() => {
                this.$nextTick(() => {
                    if (window.scrollTo) {
                        // scrollTop = 0;
                        window.scrollTo(0, 0);
                    }
                });
            }, 200);
        }
        // setTimeout(() => {
        //     this.$nextTick(() => {
        //         // this.$refs.scrollViewNav.refresh();
        //         // try {
        //         //   if ($.device && !$.device.jdjr) {
        //         //     if (sessionStorage.freestore_HomeScrollY === 'max') {
        //         //       this.$refs.scrollViewNav.scrollToElement('.homeGuessWhatYouLike', 1);
        //         //     } else {
        //         //       this.$refs.scrollViewNav.scrollTo(0, sessionStorage.freestore_HomeScrollY, 1);
        //         //     }
        //         //   }
        //         // } catch (e) {
        //         //   console.log(e);
        //         // }
        //         if (window.scrollTo) {
        //             window.scrollTo(0, 0);
        //         }
        //     });
        // }, 200);
        try {
            window.addEventListener('scroll', this.handleScroll, false);
        } catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            // const wraps = document.getElementsByClassName('cls-discovery_warpper')[0];
            let wraps = $('.cls-discovery_warpper');
            if (wraps && wraps.length) {
                document.getElementsByClassName('cls-discovery_warpper')[0].addEventListener(
                    'scroll',
                    () => {
                        let gylTabHeight = document.getElementsByClassName('jdMixFeed')[0] || document.getElementsByClassName('jdMixWaterfall')[0];
                        let scrollTop = document.getElementsByClassName('cls-discovery_warpper')[0].scrollTop;
                        if (scrollTop + 20 >= gylTabHeight.offsetTop) {
                            $('.cls-top-tab').hide();
                        } else {
                            if (scrollTop > 0) {
                                $('.cls-top-tab').show();
                            } else {
                                $('.cls-top-tab').show();
                            }
                        }
                    },
                    true
                );
            } else {
                $('.home-page-view').css('overflow-y', 'scroll');
                document.getElementsByClassName('home-page-view')[0].addEventListener(
                    'scroll',
                    () => {
                        let gylTabHeight = document.getElementsByClassName('jdMixFeed')[0] || document.getElementsByClassName('jdMixWaterfall')[0];
                        let scrollTop = document.getElementsByClassName('cls-discovery_warpper')[0].scrollTop;
                        if (scrollTop + 20 >= gylTabHeight.offsetTop) {
                            $('.cls-top-tab').hide();
                        } else {
                            if (scrollTop > 0) {
                                $('.cls-top-tab')
                                    .show()
                                    .css('background', '#fff');
                            } else {
                                $('.cls-top-tab')
                                    .show()
                                    .css('background', '#000');
                            }
                        }
                    },
                    true
                );
            }
        }, 2000);
        closeXview();
    },
    methods: {
        getMixFeed() {
            const partParam = {
                positionCode: mixPositionCode
            };
            GetSever('//v-z.jd.com/component/standardInfo.action', partParam).then(res => {
                if (res && !isEmptyObj(res)) {
                    const { data } = res;
                    if (data && !isEmptyObj(data)) {
                        const { slotVoList } = data;
                        if (slotVoList && slotVoList.length) {
                            if (slotVoList[0].isSwitch == 0) {
                                this.mixSwitch = true;
                            } else {
                                this.mixSwitch = false;
                                if ($.device && $.device.jdjr) {
                                    let nowTime = new Date().getTime();
                                    if (
                                        (!this.jdRecSwitch && (localStorage.getItem('JdRecPin') == null || localStorage.getItem('JdRecPin') == 'null')) ||
                                        this.getTimeDifference(localStorage.getItem('JdRecPin'), nowTime)
                                    ) {
                                        localStorage.setItem('JdRecPin', nowTime);
                                        this.getJdRecPin();
                                    }
                                }
                            }
                        } else {
                            // this.goodList = this.defaultGoodList;
                            this.mixSwitch = true;
                        }
                    }
                } else {
                    this.mixSwitch = true;
                }
            });
        },
        getTimeDifference(storageTime, nowTime) {
            if (storageTime == null) {
                return false;
            }
            let timeDifference = Math.abs(nowTime - storageTime);
            if (Math.floor(timeDifference / 86400000) >= 1) {
                return true;
            } else {
                return false;
            }
        },
        getJdRecPin() {
            GetSever(`${domain}/gw/generic/jrm/h5/m/getAuthrization`).then(res => {
                if (res && res.resultData && res.resultData.success) {
                    if (res.resultData.data == 1) {
                        this.jdRecSwitch = true;
                    } else if (res.resultData.data == 0 || res.resultData.data == 2) {
                        this.jdRecSwitch = false;
                    } else if (res.resultData.data == 3) {
                        //过期，需要重新发送设备信息
                        this.ImKnow();
                    }
                }
            });
        },
        ImKnow() {
            this.jdRecSwitch = false;
            if ($.device && $.device.jdjr && window.JrBridge) {
                this.getDeviceInfo();
            }
        },
        // 获取风控信息
        getDeviceInfo() {
            // 设备信息对象
            const UserAuthorityVo = {};
            // 缺省处理，当bridge桥异常无法返回设备信息时，设备信息对象为空对象
            const defaultPromise = new Promise((resolve, reject) => {
                // setTimeout(() => {
                //     alert('hahahaha3')
                //     resolve(UserAuthorityVo);
                //     console.log('缺省处理，当bridge桥异常无法返回设备信息时，设备信息对象为空对象');
                // }, 650);
            });
            // 正常处理，当bridge桥正常返回设备信息时，设备信息对象有值
            const bridgePromise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    window.JrBridge.callNative(
                        {
                            type: '9',
                            isLocation: false
                        },
                        resultData => {
                            if (typeof resultData == 'object') {
                                UserAuthorityVo.deviceType = resultData.location.osPlatform == 'iOS' ? 0 : 1;
                                //0:ios,1:android
                                UserAuthorityVo.imei = resultData.location.imei;
                                //imei安卓独有
                                UserAuthorityVo.mac = resultData.location.macAddress;
                                //Mac地址
                                UserAuthorityVo.openUdid = resultData.deviceInfo.OpenUDID;
                                //OpenUDID iOS独有
                                UserAuthorityVo.authStatus = 1;
                            }
                            setTimeout(() => {
                                this.postJdRecDevice(UserAuthorityVo);
                            }, 0);
                            resolve(UserAuthorityVo);
                            console.log('正常处理，当bridge桥正常返回设备信息时，设备信息对象有值');
                        }
                    );
                }, 500);
            });
            const racePromise = Promise.race([defaultPromise, bridgePromise]);
            return racePromise;
        },
        postJdRecDevice(params) {
            GwPostSever(`${domain}/gw/generic/jrm/h5/m/saveOrUpdateUserInfo`, params).then(res => {});
        },
        jumpPage() {
            window.location.href = 'https://m.jr.jd.com/btyingxiao/advertMoney/html/home.html';
        },
        handleScroll() {
            let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
            // 设备/屏幕高度
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 到头部的距离
            let viewBox1 = this.$refs && this.$refs.viewScrollContent; // 滚动区域
            let scrollHeight = (viewBox1 && viewBox1.scrollHeight) || 0; // 滚动条的总高度
            //滚动条到底部的条件
            // if (scrollTop + clientHeight >= scrollHeight) {
            if (scrollTop >= 80) {
                // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
                // this.isScroll = true;
                this.isScroll = false;
            }

            let t1 = 0;
            let t2 = 0;
            let timer = null; // 定时器
            let me = this;
            // scroll监听
            document.onscroll = function() {
                clearTimeout(timer);
                timer = setTimeout(isScrollEnd, 1000);
                t1 = document.documentElement.scrollTop || document.body.scrollTop;
            };

            function isScrollEnd() {
                t2 = document.documentElement.scrollTop || document.body.scrollTop;
                if (t2 == t1) {
                    if (scrollTop >= 80) {
                        me.isScroll = true;
                    }
                }
            }
        },
        onMainScrolling() {
            // this.tryProcess();
        },
        onMainScrollEnd() {
            // console.log('onMainScrollEnd');
            // this.tryProcess();
        },
        tryProcess() {
            // if (this.$refs && this.$refs.scrollViewNav) {
            //   const nbs = document.querySelector('.home-NavigaterBarScroll').offsetTop;
            //   const y = this.$refs.scrollViewNav.scroll.y;
            //   if (Math.abs(y - 10) >= Math.abs(nbs)) {
            //     this.isBarFixed = true;
            //   } else {
            //     this.isBarFixed = false;
            //   }
            // }
            // try {
            //   let homeScrollY = this.$refs.scrollViewNav.scroll.y;
            //   if (this.isBarFixed) {
            //     homeScrollY = 'max';
            //   }
            //   sessionStorage.freestore_HomeScrollY = homeScrollY;
            // } catch (e) {
            //   console.log(e);
            // }
        },
        // onMainScrollToEnd() {
        //   this.$refs.homeGuessWhatYouLike.debounceReqGuessWhatYouLike();
        // },
        onPageActivityBetterScrollRefresh(opts) {
            this.onBetterScrollRefresh(opts);
            const stt2 = setTimeout(() => {
                clearTimeout(stt2);
                if (this.$refs && this.$refs.homeGuessWhatYouLike) {
                    this.guessLikeCategorys = this.tempGuessLikeCategorys;
                    this.$nextTick(() => {
                        this.$refs.homeGuessWhatYouLike.firstLoadGuessLikeByCategory();
                    });
                }
            }, this.loadTime);
        },
        onBetterScrollRefresh(opts = {}) {
            // this.$nextTick(() => {
            //   const stt = setTimeout(() => {
            //     clearTimeout(stt);
            //     if (this.$refs && this.$refs.scrollViewNav) {
            //       if (opts.isScroll) {
            //         this.$refs.scrollViewNav.scrollToElement('.home-NavigaterBarScroll');
            //       }
            //       this.$refs.scrollViewNav.refresh();
            //     }
            //   }, 100);
            // });
        },
        onHomeGuessWhatYouLikeRefresh() {},
        loadGuessLikeByCategory({ category, index }) {
            this.guessLikeCurrentIndex = index;
            this.$refs.homeGuessWhatYouLike.loadGuessLikeByCategory(category, this.isBarFixed ? true : false);
        },
        onNavBarScroll(e) {
            // this.lockNavBarScroll = true;
            // console.log('onNavBarScroll', e);
            // this.$refs.homeNavBarScroll.scrollTo(e.x, e.y);
        },
        onNavBarScrollEnd(e) {
            console.log('onNavBarScroll11', e);
            // if (!this.lockFixBarScroll) {
            //   this.$refs.homeNavBarScroll.scrollTo(e.x, e.y);
            // }

            // setTimeout(() => {
            //   this.lockNavBarScroll = false;
            // }, 100);
        },
        onFixBarScroll(e) {
            // this.lockFixBarScroll = true;
            // console.log('onFixBarScroll', e);
            // this.$refs.homeGuessWhatYouLike.$refs.navBarScroll.scrollTo(e.x, e.y);
        },
        onFixBarScrollEnd(e) {
            // console.log('onFixBarScroll', e);
            // if (!this.lockNavBarScroll) {
            //   this.$refs.homeGuessWhatYouLike.$refs.navBarScroll.scrollTo(e.x, e.y);
            // }
            // setTimeout(() => {
            //   this.lockFixBarScroll = false;
            // }, 100);
        },
        //定时上下线
        timeLimeUpDown() {
            // this.$loading.show();
            let id = '100001029';
            if (process.env.VUE_APP_ENV === 'minner' || process.env.VUE_APP_ENV === 'dev') {
                id = '100001029';
            }

            request.contentConfigure({
                data: {
                    id,
                    auth: ['categorys', 'swiperImgs']
                },
                success: data => {
                    if (this.$refs && this.$refs.homePageDailySelect) {
                        this.$refs.homePageDailySelect.requestDailySelect();
                    }
                    if (this.$refs && this.$refs.homePageInterestFree) {
                        this.$refs.homePageInterestFree.requestInterestFree();
                    }
                    if (data && data.json) {
                        localStorage.removeItem('CACHEINSERT');
                        localStorage.setItem('CACHEINSERT', JSON.stringify(data.json));
                        if (data.json.swiperImgs && data.json.swiperImgs.length) {
                            this.list = data.json.swiperImgs;
                        }

                        if (data.json.categorys && data.json.categorys.length) {
                            this.tempGuessLikeCategorys = data.json.categorys;
                        }
                        if (data.json.banner.bigBanner) {
                            this.isOpenActivity = true;
                            this.ActivityBannerObj = data.json.banner.bigBannerObject;
                        } else {
                            this.isOpenActivity = false;
                            this.bannerBgColor = data.json.banner.bigBannerObject.backgroundColor;
                        }
                    }

                    this.onBetterScrollRefresh();

                    this.$nextTick(() => {
                        delay(() => {
                            $('.home-page-view').css({ 'padding-bottom': '1px' });
                            window.scrollTo(0, 1);
                        }, 200);
                        delay(() => {
                            $('.home-page-view').css({ 'padding-bottom': '' });
                            window.scrollTo(0, 0);
                        }, 500);
                    });
                },
                afterError: () => {
                    if (this.$refs && this.$refs.homePageDailySelect) {
                        this.$refs.homePageDailySelect.requestDailySelect();
                    }
                    if (this.$refs && this.$refs.homePageInterestFree) {
                        this.$refs.homePageInterestFree.requestInterestFree();
                    }
                    if (localStorage.getItem('CACHEINSERT')) {
                        const cacheinsertObj = JSON.parse(localStorage.getItem('CACHEINSERT'));
                        const bannerListConfig = cacheinsertObj.banner;
                        const swiperListConfig = cacheinsertObj.swiperImgs;
                        const categorysListConfig = cacheinsertObj.categorys;
                        if (swiperListConfig && swiperListConfig.length) {
                            this.list = swiperListConfig;
                        }

                        if (categorysListConfig && categorysListConfig.length) {
                            this.tempGuessLikeCategorys = categorysListConfig;
                        }
                        if (bannerListConfig.bigBanner) {
                            this.isOpenActivity = true;
                            this.ActivityBannerObj = bannerListConfig.bigBannerObject;
                        } else {
                            this.isOpenActivity = false;
                            this.bannerBgColor = bannerListConfig.bigBannerObject.backgroundColor;
                        }
                    }
                    this.onBetterScrollRefresh();
                    this.$nextTick(() => {
                        delay(() => {
                            $('.home-page-view').css({ 'padding-bottom': '1px' });
                            window.scrollTo(0, 1);
                        }, 200);
                        delay(() => {
                            $('.home-page-view').css({ 'padding-bottom': '' });
                            window.scrollTo(0, 0);
                        }, 500);
                    });
                }
            });
        },
        // onloadBannerFresh() {
        // if (this.$refs && this.$refs.homePageDailySelect) {
        //     this.$refs.homePageDailySelect.requestDailySelect();
        // }
        // if (this.$refs && this.$refs.homePageInterestFree) {
        //     this.$refs.homePageInterestFree.requestInterestFree();
        // }
        // },

        onLoadedDailySelect() {
            delay(() => {
                if (this.$refs && this.$refs.homePageActivityList) {
                    this.$refs.homePageActivityList.loadActivityList();
                }
            }, 150);

            // this.onBetterScrollRefresh();
        },
        //  专属免息
        onloadInterestFreeList() {
            delay(() => {
                if (this.$refs && this.$refs.homePageInterestFree) {
                    this.$refs.homePageActivityList.loadActivityList();
                }
            }, 150);
            // this.onBetterScrollRefresh();
        },
        onEditTip(edit) {
            this.tipContent = edit || '';
        },
        getFreeInterestCallList() {
            // this.$loading.show();
            request.getFreeInterestCallList({
                // 参数
                data: {},
                // 成功
                success: data => {
                    this.$loading.hide();
                    if (data && data.list) {
                        this.freeperiodremindlist = data.list;
                        if (data.list.length == 1) {
                            this.swiperOption = {
                                direction: 'vertical',
                                loop: true,
                                speed: 600,
                                allowTouchMove: false,
                                on: {
                                    touchStart: function() {},
                                    click: function() {}
                                },
                                autoplay: false
                            };
                        }
                    }
                },
                // 接口失败
                afterError: () => {
                    this.$loading.hide();
                }
            });
        },
        // 浏览任务组件是否展示
        switchPromise() {
            let params = getQuery();
            console.log('浏览任务组件是否展示', params);
            const rewardPromise = new Promise((resolve, reject) => {
                if (params.from == 'jrdaka' && params.final_page == 'xxf_yxmx') {
                    window.sessionStorage.setItem('from', 'jrdaka');
                    window.sessionStorage.setItem('final_page', 'xxf_yxmx');
                    resolve(true);
                } else if (window.sessionStorage.getItem('from') == 'jrdaka' && window.sessionStorage.getItem('final_page') == 'xxf_yxmx') {
                    resolve(true);
                } else {
                    reject(false);
                }
            });
            return rewardPromise;
        },
        // 初始化浏览任务组件（自动领取）
        initRewardAuto() {
            console.log('初始化浏览任务组件（自动领取）');
            setTimeout(() => {
                const articleRewardAuto = new window.JDDXREWARDAUTO.ArticleRewardAuto();
                articleRewardAuto.setRewardBarStyle(`display: block;position: fixed;top: 240px;z-index: 99999;`);
                articleRewardAuto.init();
                articleRewardAuto.setBizLine(15);
                articleRewardAuto.setActId(143);
                articleRewardAuto.renderArticleRead();
            }, 0);
        }
    },
    watch: {
        list: {
            /* eslint no-unused-vars:"off" */
            handler(curVal, oldVal) {
                oldVal = curVal;
            },
            deep: true
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};

// firstViewScroll(e, type) {
// const directionY = this.$refs.scrollViewNav.scroll.movingDirectionY;
// const y = Math.floor(Math.abs(this.$refs.scrollViewNav.scroll.y));
// const winHtg = this.winHeight;
// const offset = 80;
// const time = 800;

// switch (type) {
//   case 'scroll':
//     if (directionY >= 0 && y > offset && y < winHtg - offset) {
//       this.scrollTo(0, -winHtg, time);
//       setTimeout(() => {
//         this.resetViewScrollContent();
//       }, time + 300);
//     } else if (directionY <= 0 && y < winHtg - offset) {
//       this.scrollTo(0, 0, 2000);
//       setTimeout(() => {
//         this.resetViewScrollContent(true);
//       }, time + 100);
//     }
//     break;
//   case 'scrollEnd':
//     if (y <= offset) {
//       this.scrollTo(0, 0, 600);
//     } else if (y <= winHtg && y >= winHtg - offset) {
//       this.scrollTo(0, -winHtg, 600);
//     }
//     break;
//   default:
//     break;
// }
// },
// resetViewScrollContent(isFirstView) {
// const viewScrollContent = this.$refs.viewScrollContent;
// if (isFirstView) {
//   viewScrollContent.style.height = this.winHeight * 2 + 5 + 'px';
// } else {
//   viewScrollContent.style.height = 'auto';
// }
// this.$refs.scrollViewNav.refresh();
// },
// scrollTo(x, y, time) {
// if (scrollToLock) {
//   return;
// }
// scrollToLock = true;
// const stt = setTimeout(() => {
//   clearTimeout(stt);
//   scrollToLock = false;
// }, 50);

// this.$refs.scrollViewNav.stop();
// this.$refs.scrollViewNav.scrollTo(x, y, time);
// },
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
@import '@/scss/home.scss';

.home-page-view {
    .scroll-view-scroll {
        backface-visibility: hidden;
    }
}
.ui-fixed {
    position: fixed;
    left: 0;
    top: 0;
    background: #000;
}
.coupons {
    background: url('https://img20.360buyimg.com/cms/jfs/t26665/304/201049247/9035/d806feaf/5b88f643N726179ae.jpg') repeat-y top center;
    background-size: 100% auto;
}
.coupons ul {
    overflow: hidden;
    width: 89.333%;
    margin: auto;
}
.coupons li {
    position: relative;
    float: left;
    width: calc(50% - 6px);
    margin: 5px;
    overflow: hidden;
}
.coupons li img {
    display: block;
    width: 100%;
}
.coupons .back-shade {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
}
.coupons .back-seal {
    position: absolute;
    right: 10px;
    top: 50%;
    width: 56px;
    height: 56px;
    margin-top: -31px;
    border: 3px solid #fff;
    border-radius: 50%;
    transform: rotate(-28deg);
    -webkit-transform: rotate(-28deg);
    opacity: 1;
    transition: all 0.4s ease-in;
    -webkit-transition: all 0.4s ease-in;
}
.coupons .back-seal .up-part {
    position: absolute;
    top: 5px;
    width: 100%;
    height: 12px;
    text-align: center;
    overflow: hidden;
}
.coupons .back-seal .up-part::before {
    content: '';
    display: inline-block;
    width: 44px;
    height: 44px;
    border: 2px solid #fff;
    border-radius: 50%;
}
.coupons .back-seal .down-part {
    position: absolute;
    bottom: 5px;
    width: 100%;
    height: 12px;
    text-align: center;
    overflow: hidden;
}
.coupons .back-seal .down-part::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 44px;
    height: 44px;
    margin-left: -24px;
    border: 2px solid #fff;
    border-radius: 50%;
}
.coupons .back-seal .content-part {
    position: relative;
    line-height: 56px;
    font-size: 14px;
    text-align: center;
    color: #fff;
}
.coupons .back-seal.get-it-out {
    transform: rotate(0) scale(5);
    -webkit-transform: rotate(0) scale(6);
    opacity: 0;
}

.jrm-border-2px {
    position: relative;
}

.jrm-border-2px:before {
    display: block;
    visibility: visible;
    content: '';
    overflow: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scale(1);
    transform: scale(1);
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

@media only screen and (-webkit-min-device-pixel-ratio: 2) {
    .jrm-border-2px:before {
        right: -100%;
        bottom: -100%;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
    }
}

@media only screen and (-webkit-min-device-pixel-ratio: 3) {
    .jrm-border-2px:before {
        right: -200%;
        bottom: -200%;
        -webkit-transform: scale(0.333333);
        transform: scale(0.333333);
    }
}
.jdMixFeed {
    min-height: 300px;
}
.jdRecommend {
    position: fixed;
    /* bottom: $rem104; */
    /* top:60px; */
    height: $rem100;
    background: #f9f9f9;
    width: 100%;
    color: #333;
    font-size: $rem24;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC-Regular;
    line-height: $rem36;
    opacity: 0.95;
    .recTips {
        width: 77%;
        margin-left: $rem16;
        margin-right: $rem16;
    }
    .ImSure {
        font-size: $rem24;
        padding: $rem8 $rem14;
        border-radius: $rem32;
        background: #ffbf27;
        font-weight: 600;
        color: #333;
    }
    .ImClose {
        position: absolute;
        top: 0;
        left: 0;
        font-size: $rem24;
        text-align: center;
        width: 0;
        height: 0;
        border-top: $rem20 solid #ccc;
        border-right: $rem20 solid transparent;
        border-left: $rem20 solid #ccc;
        border-bottom: $rem20 solid transparent;
        .xx {
            position: absolute;
            top: -$rem26;
            left: -$rem18;
            width: $rem20;
        }
    }
}
/* .gyl-flex-title{
    padding: $rem28 $rem24 !important;
}
.jdTwoRowThreeCol,.jdOneRowFourCol{
    padding: $rem24 !important;
}
.jdOneRowFourCol{
    .gyl-flex-title{
        padding-top: 0 !important
    }
} */
.addnewcls {
    margin-top: 12px;
    padding: 0 12px;
    .jdOneThreeColMoreRowNew,
    .jdOneRowTuoFourColNew,
    .jdOneRowTuoThreeColNew {
        margin-bottom: 12px;
    }
}
</style>
